import React from "react";
import { RiChatSmile3Line } from "react-icons/ri";
import TestimonialCard from "../ui/TestimonialCard";
import Title from "../ui/Title";

const TestimonialsWrapper = ({}) => (
    <div className="mx-[6%]">
        <Title variant="md">
            <div className="flex items-center gap-4">
                <RiChatSmile3Line {...{ style: { transform: "scale(-1, 1)" } }} />
                <span>Témoignages</span>
            </div>
        </Title>
        <div className="container mx-auto gap-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mt-8 mb-10">
            <TestimonialCard
                full={4}
                half={1}
                title="Super app !"
                author="Camille C."
                review="Après avoir longtemps cherché une application pour me détendre au travail, j’ai opté pour Happiz. Au début, j'étais sceptique à l’idée de l’hypnose et je me suis dit que j’allais tout de même essayer. Assez étonnamment je ne ressens plus ce sentiment d’anxiété au travail… Il y a comme une forme de distance qui s’est créée et qui me fait énormément de bien. Je recommande."
            />
            <TestimonialCard
                full={5}
                half={0}
                title="Meilleur application d'hypnose !"
                author="Mélanie B."
                review="En moins d’un mois j’ai retrouvé un sommeil paisible grâce à leur programme sur l’insomnie, après avoir essayé différentes solutions toutes sans succès. Cette app m’a également permis de découvrir plusieurs autres thèmes intéressants par des récits hypnotiques toujours apaisants. J’ai hâte d’écouter tous leurs audios !!"
            />
            <TestimonialCard
                full={5}
                half={0}
                title="Très belle app"
                author="Thomas B."
                review="J’adore, l’app est bien faite, facile à prendre en main."
            />
            <TestimonialCard
                full={4}
                half={1}
                title="Je suis super Happiz 😀"
                author="Chloé N."
                review="Pour moi l’hypnose ça ne me parlait pas… et ça fait mnt 2 mois que j’utilise cette app et je dois dire que je suis très étonnée de mon niveau de stress qui a baissé. Je me sens vraiment mieux."
            />
            <TestimonialCard
                full={4}
                half={1}
                title="Simple, efficace et bon prix"
                author="Sébastien C."
                review="Je recommande. L’app est belle, simple et je trouve que moins 7 euros par mois pour aller mieux c’est honnête."
            />
            <TestimonialCard
                full={5}
                half={0}
                isEnd
            />
        </div>
    </div>
)

export default TestimonialsWrapper